import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
// import store from './store'

// Vue composition API
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI);

// Konva
import VueKonva from 'vue-konva'
Vue.use(VueKonva)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

Vue.config.productionTip = false

export const bus = new Vue();

new Vue({
  router,
  // store,
  bus,
  render: h => h(App)
}).$mount('#app')
